import { call, put, takeEvery } from 'redux-saga/effects';
import { NewDealerActionKeys } from '..';
import { IEntityWithMessages } from '../../../services/HttpService';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { processMessages, showFailedRequestDialog } from '../../sagaUtils';
import { newDealerActionCreators } from '../newDealerActionCreators';
import { AddNewDealerRequestCompleteEvent } from '../newDealerActionTypes';
import * as api from '../newDealerApi';
import { INewDealerRequestCompleteEvent } from '../newDealerInterfaces';

function* addNewDealerRequestCompleteEvent(action: AddNewDealerRequestCompleteEvent) {
  //yield put(newDealerActionCreators.toggleEventSave(action.payload));
  const response: IApiExecuteRespone<IEntityWithMessages<INewDealerRequestCompleteEvent>> = yield call(
    api.addNewDealerRequestCompleteEvent,
    action.payload
  );

  if (!response.requestFailed && response.value) {
    yield processMessages(response.value);

    if (response.value.value) {
      yield put(newDealerActionCreators.setCompleteEvent(response.value.value));
    }
  } else {
    yield showFailedRequestDialog(response);
  }

  //yield put(newDealerActionCreators.toggleEventSave(action.payload));
}

export function* watchAddNewDealerRequestCompleteEvent() {
  yield takeEvery(NewDealerActionKeys.ADD_NEW_DEALER_REQUEST_COMPLETE_EVENT, addNewDealerRequestCompleteEvent);
}
